import { Box, Paper, Typography } from '@mui/material'
import React from 'react'
import { NavLink } from 'react-router-dom'
import { RemovedEmployeesSelector } from '../../../redux/corporateService'
import MpSvgIcon from '../atom/MpSvgIcon'

const RecentlyRemovedCard = () => {
  const deletedEmployees = RemovedEmployeesSelector()
  return (
    <NavLink to={'/home/removed'}>
      <Paper
        sx={{
          borderRadius: '20px',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '20px',
          marginTop: '40px',
          marginBottom: '40px',
        }}>
        <Typography>Recently Removed</Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}>
          <Typography
            sx={{
              border: '1px solid gray',
              paddingLeft: '10px',
              paddingRight: '10px',
              borderRadius: 10,
            }}>
            {deletedEmployees.length}
          </Typography>
          <MpSvgIcon icon={'collapse'} />
        </Box>
      </Paper>
    </NavLink>
  )
}

export default RecentlyRemovedCard
